// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"95f1c28b","157":"225592f1","186":"c3ba14b0","339":"5826d930","395":"667b44ea","471":"16a8ddca","519":"d19238a1","573":"41747743","616":"308beead","766":"d82aa4fa","912":"d8749671","924":"58cc8e4f"}[chunkId] + ".chunk.js";
};